import { Outlet } from "react-router-dom";
import Footer from "./Footer";
import Header from "./Header";

const Layout = ({ children }) => {
    return (
        <section>
            <Header />
            <div>
                <main><Outlet/></main>
            </div>
            <Footer />
        </section>
    )
}

export default Layout;